module.exports = __webpack_public_path__ + "officialStatic/img/smartBg.9dc0684.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/smartCampus/smartBg.jpg
// module id = bCEa
// module chunks = 0